import { makeStyles } from '@material-ui/core/styles';
import { COLOR_WHITE } from '../components/utilities/Material';
import { COLOR_GREY } from '../components/utilities/MaterialWatchman';
import { getStyle, mergeStyles } from './stylesSelector';
import { cloneDeep } from 'lodash';
import { ReactComponent as Logo } from '../resources/images/logo.svg';
import { ReactComponent as LogoWhite } from '../resources/images/logo-white.svg';

export const DesktopNavBarStyle = makeStyles(theme => {
    /* Default Styles */
    const styles = {
        root: {
            backgroundColor: theme.palette.primary.dark,
            paddingRight: theme.spacing(3),
            paddingTop: theme.spacing(3),
            position: 'fixed',
            top: 0,
        },
        toolBar: {
            display: 'flex',
            justifyContent: 'space-between',
        },
        logoImage: {
            display: 'block',
            marginBottom: theme.spacing(2),
            marginLeft: theme.spacing(4),
        },
        navLink: {
            textDecoration: 'none',
            fontfamily: theme.typography.fontFamily,
            color: getActiveDesktopLinkStyles(theme).contrastText,
            fontStyle: 'normal',
            fontWeight: '600',
            fontSize: '18px',
            lineHeight: '25px',
            textAlign: 'center',
            letterSpacing: '0.16px',
            paddingBottom: '26px',
            marginRight: '24px',
            marginLeft: theme.spacing(3),
            '&:hover': {
                textDecoration: 'none',
                cursor: 'pointer',
            },
        },
        activeNavLink: {
            color: getActiveDesktopLinkStyles(theme).color,
            borderBottom: getActiveDesktopLinkStyles(theme).borderBottom,
        },
        chatBarOpen: {
            background: COLOR_WHITE,
            boxShadow: '0px 0.788606px 3.15442px rgba(186, 186, 186, 0.25)',
            borderRadius: '15px 15px 0px 0px',
            height: '37.85px',
            position: 'inherit',
        },
        chatBarOpenContent: {
            display: 'flex',
            alignItems: 'center',
            textAlign: 'center',
            flexDirection: 'row',
            height: '37.85px',
            justifyContent: 'space-between',
        },
        chatBarOpenText: {
            lineHeight: '19px',
            letterSpacing: '0.126177px',
            color: theme.palette.primary.main,
            order: 2,
            flexGrow: 5,
        },
        infoIcon: {
            color: theme.palette.primary.dark,
            height: '20px',
            width: '20px',
            cursor: 'pointer',
            order: 1,
            flexGrow: 1,
        },
        closeChatArrow: {
            color: theme.palette.primary.dark,
            transform: 'rotate(90deg)',
            cursor: 'pointer',
            order: 3,
            flexGrow: 1,
            '& path': {
                strokeWidth: '1.8px',
            },
        },
    };

    /* Add watchman specific styles */
    let watchmanStyles = {
        /* logoImage */
        logoImage: {
            width: '160px',
            height: '45px',
        },

        /* appBarRoot */
        appBarRoot: {
            backgroundColor: COLOR_WHITE,
            boxShadow: '0px 1px 4px rgba(186, 186, 186, 0.25)',
        },

        /* desktopLinks */
        desktopLinks: {
            paddingTop: theme.spacing(0.75),
        },
    };
    // merge
    watchmanStyles = mergeStyles(cloneDeep(styles), watchmanStyles);

    /* Add Ned specific styles */
    let nedStyles = {
        /* logoImage */
        logoImage: {
            width: '67px',
            height: '37px',
        },
    };
    // merge
    nedStyles = mergeStyles(cloneDeep(styles), nedStyles);

    const stylesMap = {
        ned: nedStyles,
        watchman: watchmanStyles,
    };

    return getStyle(stylesMap);
});

export const getActiveDesktopLinkStyles = theme => {
    /* watchman specific */
    const watchmanActiveDesktopLinkStyles = {
        color: theme.palette.primary.main,
        borderBottom: `5px solid ${theme.palette.primary.main}`,
        contrastText: COLOR_GREY.main,
    };

    /* Ned specific */
    const nedActiveDesktopLinkStyles = {
        color: theme.palette.primary.light,
        borderBottom: `5px solid ${theme.palette.primary.light}`,
        contrastText: theme.palette.primary.contrastText,
    };

    const activeDesktopLinkStylesMap = {
        ned: nedActiveDesktopLinkStyles,
        watchman: watchmanActiveDesktopLinkStyles,
    };

    return getStyle(activeDesktopLinkStylesMap);
};

export const { DesktopMenuLogo } = getStyle({
    ned: { DesktopMenuLogo: LogoWhite },
    watchman: { DesktopMenuLogo: Logo },
});
